export const DELETE_FILE_REFERENCE_SUCCESS = 'DELETE_FILE_REFERENCE_SUCCESS';

export const deleteFileReferenceSuccess = ( id: string ) => ({
    type: DELETE_FILE_REFERENCE_SUCCESS,
    payload: {
        id,
    },
});
